export class TrapReceiverModel {
  constructor(public id: number, public ipAddress: string, public port: number) {}
}

export class SnmpConfigurationModel {
  public communityName: string = "";
  public trapReceivers: Array<TrapReceiverModel> = new Array<TrapReceiverModel>();  
}
